import { z } from 'zod/v4'

export const apiTokenValidationSchema = z.object({
  token: z.string().trim().min(1, 'API token is required'),
})

export type ApiTokenValidationInput = z.infer<typeof apiTokenValidationSchema>
